// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"card_imgStyle__25Ewd"};